<template>
	<form @submit.prevent="submit">
		<div v-if="errorMessage" class="notification is-danger is-light">
			{{ errorMessage }}
		</div>
		<required-field
			:error="$v.profile.firstname.$error"
			:required="$v.profile.firstname.required"
			label="First name"
		>
			<input
				v-model.trim="$v.profile.firstname.$model"
				class="input"
				type="text"
				:class="{ 'is-danger': $v.profile.firstname.$error }"
			/>
		</required-field>
		<required-field
			:error="$v.profile.lastname.$error"
			:required="$v.profile.lastname.required"
			label="Last name"
		>
			<input
				v-model.trim="$v.profile.lastname.$model"
				class="input"
				type="text"
				:class="{ 'is-danger': $v.profile.lastname.$error }"
			/>
		</required-field>
		<required-field
			:error="$v.profile.email.$error"
			:required="$v.profile.email.required"
			label="Email"
		>
			<input
				v-model.trim="$v.profile.email.$model"
				class="input"
				type="text"
				:class="{ 'is-danger': $v.profile.email.$error }"
			/>
			<p v-if="!$v.profile.email.email" class="help is-danger">
				We require a valid email address
			</p>
		</required-field>
		<required-field label="Job title (optional)">
			<input
				v-model.trim="$v.profile.jobtitle.$model"
				class="input"
				type="text"
			/>
		</required-field>
		<required-field
			:error="$v.profile.image.$error"
			:required="$v.profile.image.required"
			label="Profile photo"
		>
			<image-upload
				:value="$v.profile.image.$model"
				@update="updateImage"
			></image-upload>
		</required-field>
		<hr />
		<div class="buttons">
			<button
				class="button is-primary gtm-save"
				:class="{ 'is-loading': fetching }"
				:disabled="!isValid"
			>
				Save</button
			><button class="button is-outlined gtm-cancel" @click.prevent="cancel">
				Cancel
			</button>
		</div>
	</form>
</template>

<script>
import formMixins from "./formMixins";
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
export default {
	name: "FormUserProfile",
	mixins: [formMixins, validationMixin],
	validations: {
		profile: {
			firstname: { required },
			lastname: { required },
			email: { required, email },
			jobtitle: {},
			image: { required }
		}
	},
	props: {
		userDetail: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			profile: null
		};
	},
	computed: {
		isValid() {
			return !this.$v.$invalid;
		}
	},
	mounted() {
		if (this.userDetail) {
			this.profile = JSON.parse(JSON.stringify(this.userDetail));
		}
	},
	methods: {
		submit() {
			this.$v.$touch();
			if (this.isValid) {
				const data = this.$v.profile.$model;
				this.$emit("submit", data);
			}
		},
		cancel() {
			this.$emit("cancel");
		},
		updateImage(url) {
			this.$v.profile.image.$model = url;
		}
	}
};
</script>

<style scoped>
form {
	margin-bottom: 1.5rem;
}
</style>
